module.exports = __webpack_public_path__ + "img/sommer.6e37ddce.png";